module.exports = __webpack_public_path__ + "assets/formosa-alt.e7c370b9.svg";